import travelData from '../data/travelInfoData.json';
import {TravelInfoView} from '../views/travelInfoView.jsx';
import { useParams, useSearchParams } from "react-router-dom";

function TravelInfo() {
  const [searchParams] = useSearchParams();
  const label = searchParams.get("label");
  const { id, mode } = useParams();
  const location = travelData[id][mode];
  const title = travelData[id]?.title;

  if (!location) {
    return <div>Location not found.</div>;

  }

  function handleNextPageACB() {
    window.location.hash = `#/checkpoint/${id}`;
  }

  return (
    <TravelInfoView 
      title={title}
      location={location}
      onNext={handleNextPageACB}
      label={label}
      mode={mode}
    />
  );
}

export {TravelInfo };
